import { render } from "./Edit.vue?vue&type=template&id=3a247c8e"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/niq/Documents/Project Apps/TMI/Helpdesk App/apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__